 
import { Injectable } from '@angular/core';
import { SupabaseClientService } from './supabase-client.service';
import { PageViewLog, UserActivityLog } from '@app-libs/model';

@Injectable({
  providedIn: 'root',
})
export class ActivityTrackingService {
  // private readonly logger = new Logger(ActivityTrackingService.name);

  constructor(private supabaseService: SupabaseClientService) {}

  private getSupabase() {
    return this.supabaseService.getClient();
  }

  async trackPageView(
    user_id: string,
    page: string,
    referrer_url?: string,
    session_id?: string,
    device?: any
  ): Promise<PageViewLog> {
    if (!user_id) {
      // console.warn('User not logged in, skipping page view tracking');
      return {} as PageViewLog;
    }

    const page_view: Partial<PageViewLog> = {
      user_id: user_id,
      page_url: page,
      referrer_url: referrer_url,
      session_id: session_id,
      device_info: device,
    };
    return this.insertPageView(page_view as PageViewLog);
  }

  // Save user activity to database
  private async insertPageView(page_view: PageViewLog): Promise<PageViewLog> {
    // console.debug("page_view", page_view);
    const { data, error } = await this.getSupabase()
      .from('page_views_log')
      .insert(page_view)
      .select('*')
      .single();

    if (error) {
      throw error;
    }

    return data;
  }

  async createUserActivity(
    user_id: string,
    type: string,
    sub_type?: string,
    details?: any
  ): Promise<UserActivityLog> {
    // console.debug(`Logging user activity [${type}:${sub_type} -> ${details ? JSON.stringify(details) : ''}]`);

    const activity: Partial<UserActivityLog> = {
      user_id: user_id,
      activity_type: type,
      activity_sub_type: sub_type,
      details: details,
    };
    return this.insertUserActivity(activity as UserActivityLog);
  }

  // Save user activity to database
  private async insertUserActivity(
    activity: UserActivityLog
  ): Promise<UserActivityLog> {
    // console.debug("activity", activity);
    const { data, error } = await this.getSupabase()
      .from('user_activity_log')
      .insert(activity)
      .select('*')
      .single();

    if (error) {
      throw error;
    }

    return data;
  }
}
